import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import cn from 'classnames';
import { StatusDotIcon } from '../Icons/StatusDotIcon';
import styles from './AvatarGroup.module.scss';
export const AvatarGroup = ({ avatars, isAssignedToAgent }) => {
    const formattedAgents = avatars.slice(0, 3);
    return (_jsx(_Fragment, { children: _jsxs("div", { className: cn(styles.avatarGroup, {
                [styles.isTalkingToAgent]: avatars.length === 1 && isAssignedToAgent,
            }), children: [formattedAgents.map(({ agent_id, avatar, name }) => (_jsx("div", { className: styles.avatar, children: _jsx("img", { src: avatar, alt: name }) }, agent_id))), isAssignedToAgent && avatars.length === 1 && (_jsx("span", { className: styles.status, children: _jsx(StatusDotIcon, { status: avatars[0].status }) }))] }) }));
};
